/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 */

import ShareTianmiTest from '../views/share/tianmi_test';
import ShareTianmi from '../views/share/tianmi';
import ShareTemp from '../views/share/miqu_temp';
import MiquPreview from '../views/share/miqu_preview';

import FAQTianmi from '../views/warning/faq_tianmi';

import FAQAccount from '../views/warning/tianmi/account';
import FAQCertify from '../views/warning/tianmi/certify';
import FAQFunction from '../views/warning/tianmi/function';
import FAQRecharge from '../views/warning/tianmi/recharge';
import FAQMore from '../views/warning/tianmi/more';

import CivilizationPact from '../views/warning/tianmi/civilization';  // 文明公约
import PrivacyMiQu from '../views/privacy/miqu_ios';
import AgreementChatroom from '../views/miqu/agreement_chatroom';

import ShareClose from '../views/common/close.vue';


const router = {
    '/share-tianmi-test': ShareTianmiTest,
    '/share-tianmi': ShareTianmi,
    '/share-tianmi-new': ShareTianmi,
    // '/share-miqu-2': ShareTianmi,
    '/share-miqu-2': ShareClose,
    '/share-miqu-3': ShareTianmi,
    '/share-miqu-4': ShareTianmi,
    '/share-miqu-5': ShareTianmi,
    '/share-miqu-6': ShareTianmi,
    '/share-miqu-7': ShareTianmi,
    '/share-miqu-8': ShareTianmi,

    '/faq-tm': FAQTianmi,
    '/share-temp': ShareTemp,
    '/miqu-preview': MiquPreview,

    '/faq-tm-account': FAQAccount,
    '/faq-tm-certify': FAQCertify,
    '/faq-tm-function': FAQFunction,
    '/faq-tm-recharge': FAQRecharge,
    '/faq-tm-more': FAQMore,

    '/faq-tm-civilization': CivilizationPact,
    '/privacy-miqu': PrivacyMiQu,
    '/agreement-chatroom': AgreementChatroom
};


export default router;